import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const WrapTextStyle: SystemStyleObject<Theme> = {
  overflow: 'hidden',
  overflowWrap: 'anywhere',
};
